import React from 'react';

export default function DataDeletion() {
  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '40px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      lineHeight: '1.6'
    }}>
      <h1>Data Deletion Request</h1>
      
      <p>
        At AZTrainers, we respect your privacy and your right to control your personal data. 
        If you would like to delete your account and all associated data, please follow the 
        instructions below.
      </p>

      <h2>How to Delete Your Account</h2>
      
      <p>You can delete your AZTrainers account directly from the mobile app:</p>
      
      <ol>
        <li>Open the AZTrainers app</li>
        <li>Go to your <strong>Profile</strong></li>
        <li>Tap <strong>"Delete Account"</strong></li>
        <li>Confirm your decision</li>
      </ol>

      <p>
        Your account and all associated data will be permanently deleted immediately.
      </p>

      <h3>Alternative: Email Request</h3>
      
      <p>
        If you are unable to access the app, you can email{' '}
        <a href="mailto:support@aztrainers.com">support@aztrainers.com</a> with 
        "Delete My Account" in the subject line. Include your account email address 
        and we'll process your request within 30 days.
      </p>

      <h2>What Gets Deleted</h2>
      
      <p>When you request account deletion, we will remove:</p>
      <ul>
        <li>Your profile information</li>
        <li>Your account credentials</li>
        <li>Your session history</li>
        <li>Any messages or communications</li>
        <li>Analytics data associated with your account</li>
      </ul>

      <h2>Important Notes</h2>
      
      <ul>
        <li>
          In-app deletion is <strong>immediate and cannot be undone</strong>
        </li>
        <li>
          If you are a trainer with upcoming sessions, please cancel them before 
          deleting your account
        </li>
        <li>
          Financial records may be retained for legal and tax purposes as required by law
        </li>
        <li>
          Email-based deletion requests will be processed within 30 days
        </li>
      </ul>

      <h2>Questions?</h2>
      
      <p>
        If you have any questions about data deletion or privacy, please contact us at{' '}
        <a href="mailto:support@aztrainers.com">support@aztrainers.com</a>
      </p>

      <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #ccc' }}>
        <p style={{ fontSize: '14px', color: '#666' }}>
          Last Updated: November 2025
        </p>
      </div>
    </div>
  );
}